import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import styles from './Dashboard.module.css';
import UserSectionController from '../components/dashboard/UserSectionController';
import WithdrawFundsController from '../components/dashboard/WithdrawFundsController';
import AddFundsController from '../components/dashboard/AddFundsController';
import FundTransferStatus from '../components/dashboard/FundTransferStatus';

import {
  Container,
} from '@mui/material';

const Dashboard = ({ section }) => {
  const [sectionToShow, setSectionToShow] = useState(section);
  
  const renderSection = () => {
    switch (sectionToShow) {
      case 'dashboard':
        return <UserSectionController setSectionToShow={setSectionToShow} />;
      case 'withdraw':
        return <WithdrawFundsController />;
      case 'addfunds':
        return <AddFundsController setSectionToShow={setSectionToShow}  />;
      case 'fundtransferstatus':
        return <FundTransferStatus />;
      default:
        return;
    }
  };

  useEffect(() => {
    // Update sectionToShow whenever the section prop changes
    setSectionToShow(section);
  }, [section]); // Add section as a dependency

  return (
    <Container disablepadding="true" sx={{ width: "100%" }} className={styles.dashboard}>
      <Grid container xs={12} sx={{ width: "100%" }} >
        {renderSection()}
      </Grid>
    </Container>
  );
};

export default Dashboard;
